export default __webpack_public_path__ + "static/media/Inter-Black.768169b1.woff2";